export default __webpack_public_path__ + "static/media/newfog2.ef03ca35.png";